<template>
  <div>
    <p class="Ptitle">買い物かご</p>
    <div class="cart_main" v-show="cartInfo.length">
      <table class="cart_main_table">
        <tr class="tableTrFirst">
          <td>全てを選択&nbsp;&nbsp;<input type="checkbox" v-model="checkAll"></td>
          <td>商品画像</td>
          <td>商品名</td>
          <td>単価</td>
          <td>数量</td>
          <td>数量</td>
        </tr>
        <tr class="tableTrTwo" v-for="(item,$index) in cartInfo ">
          <td><span><input type="checkbox" :value="item.goods_id" v-model="checked"
                           @click="currClick(item,$index)"></span>
          </td>
          <td><span><img :src="item.goods_img"></span></td>
          <td><span class="tableGoodsName">{{item.goods_name}}</span>
          </td>
          <td><span>￥{{item.goods_price}}</span></td>
          <td><span> <el-input-number size="mini" v-model="item.goods_number" ref="goods" :goodsId="item.goods_id"
                                      :min="item.limit_buy_min" :max="item.limit_buy_max"
                                      @change="(value) => updateCartNum(value, item.goods_id)"></el-input-number></span>
          </td>
          <td><span @click="delCart(item)" style="cursor: default">削除</span></td>
        </tr>
      </table>
      <div class="cart_main_bottom">
        <div class="m_bottom_top">
          <span>小計<label>{{listnum}}</label>点</span>
          <span>合計:<label>{{totalMoney.toLocaleString()}}円</label></span>
        </div>
        <div class="m_bpttom_btn">
          <button @click="goCartTwo">即座に支払う</button>
          <button @click="goHome">買い付けを続ける</button>
        </div>
      </div>
    </div>
    <div class="no_goods" v-show="!cartInfo.length">
      <img src="../../assets/images/personal/wu.png">
      <span>買い物かごには商品が入っていません</span>
    </div>

    <div class="cart_Mmain" v-show="cartInfo.length">

      <ul class="cart_PmainUl">
        <li v-for="(item,$index) in cartInfo ">
          <div class="cart_PmainCheck">
            <input type="checkbox" :value="item.goods_id" v-model="checked" @click="currClick(item,$index)">
          </div>
          <div class="cart_PmainImg">
            <img :src="item.goods_img">
          </div>
          <div class="cart_PmainContent">
            <p>{{item.goods_name}}</p>
            <p>{{item.goods_price.toLocaleString()}}円</p>
            <p>
              <el-input-number size="mini" v-model="item.goods_number" ref="goods"
                               :goodsId="item.goods_id"
                               :min="item.limit_buy_min" :max="item.limit_buy_max"
                               @change="(value) => updateCartNum(value, item.goods_id)">

              </el-input-number>
            </p>
          </div>
          <div class="cart_PmainAction" @click="delCart(item)" style="cursor: default">删除</div>
        </li>
      </ul>
      <div class="cart_PmainFooter">
        <span>全てを選択&nbsp;&nbsp;<input type="checkbox" v-model="checkAll"></span>
        <div class="PmainFooterHe">
          <span>合計：<label>{{totalMoney.toLocaleString()}}円</label></span>
          <span><button @click="goCartTwo">決算</button></span>
        </div>
      </div>
    </div>
    <div class="Mno_goods" v-show="!cartInfo.length">
      <div class="no_goodsMain">
        <img src="../../assets/images/personal/wu.png">
        <span>買い物かごには商品が入っていません</span>
      </div>
    </div>
    <!--<div class="cart_bottom"></div>-->
  </div>
</template>

<script>
  import {getCart, updateCart, deleteCart} from './../../api/interface/users'
  export default{
    name: "",
    data(){
      return {
        msg: 'hello vue',
        checked: [],//选中的商品长度
        checknumber: [],
        totalPrice: [],
        select: "",
        cartInfo: [],
        editState: 0,  //编辑状态
        goods_id: 0
      }
    },
    beforeMount(){
      this.getCart();
    },
    computed: {
      totalMoney: function (item, index) {//计算商品价格
        let sum = 0;
        for (let i = 0; i < this.totalPrice.length; i++) {
          sum += this.totalPrice[i];
        }
        return sum;
      },
      listnum: function (item, index) {
        let checknum = 0;
        for (let i = 0; i < this.checknumber.length; i++) {
          checknum += this.checknumber[i]
        }
        return checknum
      },
      checkAll: {
        get: function () {
          return this.checkedCount == this.cartInfo.length;
        },
        set: function (value) {//设置
          console.log(value);
          var _this = this;
          if (value) {
            this.totalPrice = [];
            this.checknumber = [];
            this.checked = this.cartInfo.map(function (item) {
              item.checked = true;
              let total = item.goods_price * item.goods_number;
              _this.totalPrice.push(total);
              let goodsnum = item.goods_number;//计算商品数量
              _this.checknumber.push(goodsnum) //把商品数量添加到数组
              return item.goods_id
            })
          }
          else {
            this.checked = [];
            this.totalPrice = [];
            this.checknumber = [];
            this.cartInfo.forEach(function (item, index) {
              item.checked = false;
            });
          }
        }
      },
      //获取选中的商品长度
      checkedCount: {
        get: function () {
          return this.checked.length;
        }
      }
    },

    methods: {
      // 获取购物车数据
      getCart(){
        getCart().then(result => {
          console.log(result);
          if (result.code === 1) {
            this.cartInfo = result.resData;
            console.log(this.cartInfo);
          }
        }).catch(err => {
        })
      },
      //删除购物车数据
      delCart(item){
        console.log(item.cart_id);
        let cartGoodsInfo = {
          cart_id: item.cart_id
        }
        deleteCart(cartGoodsInfo).then(result => {
          if (result.code === 1) {
            this.$message({
              message: result.message,
              type: 'success'
            });
            this.cartInfo.forEach((t, index) => {
              if (t.cart_id == item.cart_id) {
                this.cartInfo.splice(index, 1)
              }
            })


          }
        }).catch(err => {
          console.log(err);
          if (err.code == 2) {
            console.log("参数错误")
          } else if (err.code == 55) {
            console.log("操作对象不存在")
          }
        })
      },
      getGoodsId(e){
        console.log(e);
      },

      //更新购物车数据
      updateCartNum(value, goods_id){
//        console.log(this.$refs.goods);
        console.log(goods_id);
        let cartGoodsInfo = {
          goods_id: goods_id,
          goods_number: value
        }

        updateCart(cartGoodsInfo).then(result => {
          console.log(result);

          if (result.code === 1) {
            console.log(result.message)
          }
        }).catch(err => {
          console.log(err);
          if (err.code === 2) {
            console.log("参数不能为空")
          }
          else if (err.code === 51) {
            console.log("商品不存在")
          } else if (err.code === 55) {
            console.log(err.message)
          }
        })
      },

      currClick: function (item, index) {
        var _this = this;
        if (typeof item.checked == 'undefined') {
          this.$set(item, 'checked', true);
          let total = item.goods_price * item.goods_number;//计算商品总价
          this.totalPrice.push(total);//把商品金额添加到数组
          let goodsnum = item.goods_number;//计算商品数量
          this.checknumber.push(goodsnum) //把商品数量添加到数组
        }
        else {
          item.checked = !item.checked;
          if (item.checked) {
            this.totalPrice = [];
            this.checknumber = [];
            this.cartInfo.forEach(function (item, index) {//遍历商品信息
              if (item.checked) {
                let total = item.goods_price * item.goods_number;
                _this.totalPrice.push(total);
                let goodsnum = item.goods_number;//计算商品数量；
                _this.checknumber.push(goodsnum)
              }
            });
          }
          else {
            this.totalPrice = [];
            this.checknumber = [];
            this.cartInfo.forEach(function (item, index) {
              if (item.checked) {
                let total = item.goods_price * item.goods_number;
                _this.totalPrice.push(total);
                let goodsnum = item.goods_number;//计算商品数量;
                _this.checknumber.push(goodsnum)
              }
            });
          }
        }
      },
      changenum: function (value) {
        console.log(value);
      },
      goHome: function () {
        this.$router.push({path: "/"})
      },
      goCartTwo(){
        console.log(this.checked);
        if (this.checked.length) {
          this.$router.push({path: "/pay", query: {goods_id: this.checked}})
        } else {
          this.$message({
            message: '最低选择一个商品',
            type: 'error',
            duration: 2000
          });
        }
      },
    },
    components: {},
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .Ptitle {
      height: 50px;
      width: 100%;
      text-align: center;
      letter-spacing: $letter;
      line-height: 50px;
      font-size: 16/$default-w+rem;
      background-color: $TitColor;
      color: $whiteColor;
      /*position: absolute;*/
      /*top: 0;*/
      /*left: 0;*/
      /*right: 0;*/
      border-bottom: 1px solid #ddd;
    }
    .cart_main {
      display: none;
    }
    .cart_Mmain {
      position: absolute;
      top: 50px;
      left: 0;
      right: 0;
      bottom: 50px;
      overflow-y: scroll;
      overflow-x: hidden;
      input[type='checkbox'] {
        width: 14px;
        height: 14px;
        -webkit-appearance: none;
        border: 1px solid $navcolor;
        border-radius: 2px;
        outline: none;
        background-color: white;
        background-image: url("../../assets/images/goods/kong.png");
      }
      input[type='checkbox']:checked {
        background-clip: content-box;
        background-image: url("../../assets/images/goods/dui.png");
      }
      .cart_PmainUl {
        margin-top: 2px;
        height: 110px;
        width: 100%;
        li {
          height: 100%;
          display: flex;
          justify-content: space-around;
          background-color: white;
          border-bottom: 1px solid #dddddd;
          .cart_PmainCheck {
            width: 1rem;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            /*background-color: #dd6161;*/
          }
          .cart_PmainImg {
            width: 2.5rem;
            height: 100%;
            /*background-color: #996600;*/
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 86px;
              height: 90px;
            }
          }
          .cart_PmainContent {
            height: 100%;
            width: 4.5rem;
            /*background-color: #690;*/
            display: flex;
            flex-flow: wrap;
            align-content: center;
            font-size: 14/$default-w+rem;
            p {
              margin-left: 10px;
              width: 100%;
            }
            p:nth-child(1) {
              font-size: 18/$default-w+rem;
              color: $navcolor;
            }
            p:nth-child(2) {
              color: red;
            }
            p:nth-child(3) {
              width: 100%;
              margin: 5px 0;
              .el-input-number {
                width: 90px;
                margin-left: 10px;
              }
            }
          }
          .cart_PmainAction {
            height: 100%;
            width: 2rem;
            /*background-color: red;*/
            text-align: center;
            line-height: 100px;
          }
        }
      }
      .cart_PmainFooter {
        font-size: 14px;
        height: 40px;
        width: 100%;
        padding-left: 2%;
        box-sizing: border-box;
        background-color: white;
        position: fixed;
        bottom: 50px;
        left: 0;
        right: 0;
        line-height: 40px;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #dddddd;
        span {
          display: inline-block;
          label {
            color: #dd6161;
            font-size: 14px;
          }
        }
        .PmainFooterHe {
          span:nth-child(1) {
            margin: 0 15px;
          }
          span:nth-child(2) {
            button {
              width: 2.5rem;
              height: 40px;
              border: none;
              outline: none;
              color: white;
              background-color: $navcolor;
              letter-spacing: $letter;
              font-size: 14px;
            }
          }
        }
      }
    }
    .no_goods {
      display: none;
    }
    .Mno_goods {
      position: absolute;
      top: 50px;
      left: 0;
      right: 0;
      bottom: 50px;
      overflow-x: hidden;
      overflow-y: scroll;
      font-size: 12px;
      width: 100%;
      display: flex;
      align-items: center;
      background-color: #fafafa;
      .no_goodsMain {
        position: absolute;
        width: 100%;
        height: 150px;
        line-height: 150px;
        top: 50%;
        transform: translate(0, -50%);
        display: flex;
        justify-content: center;
        img {
          width: 100px;
          height: 150px;
        }
        a {
          color: $navcolor;
        }
      }
    }
  }

  @media screen and(min-width: $P750screen) {
    .Ptitle {
      display: none;
    }
    .cart_main {
      width: $mainwidth;
      background-color: white;
      margin: 0 auto;
      display: block;
      .cart_main_table {
        width: 100%;
        background-color: $bgcolor;
        border-collapse: collapse;
        tr td {
          width: 136px;
          text-align: center;
          input[type='checkbox'] {
            width: 14px;
            height: 14px;
            -webkit-appearance: none;
            border: 1px solid $navcolor;
            border-radius: 2px;
            outline: none;
            background-color: white;
            background-image: url("../../assets/images/goods/kong.png");
          }
          input[type='checkbox']:checked {
            background-clip: content-box;
            background-image: url("../../assets/images/goods/dui.png");
          }
        }
        .tableTrFirst {
          height: 50px;
        }
        .tableTrTwo {
          height: 120px;
          margin-top: 5px;
          background-color: white;
          .el-input-number {
            width: 100px;
          }
          img {
            display: inline-block;
            width: 86px;
            height: 90px;
          }
        }
      }
      .cart_main_bottom {
        width: 100%;
        height: 160px;
        background-color: $bgcolor;
        margin-top: 10px;
        .m_bottom_top {
          height: 60px;
          line-height: 60px;
          float: right;
          span {
            font-size: 14px;
            margin-right: 20px;
            label {
              padding: 0 5px;
              color: $navcolor;
              font-size: 18px;
            }
          }
        }
        .m_bpttom_btn {
          float: right;
          height: 100px;
          width: $mainwidth;
          background-color: white;
          /*background-color: red;*/
          color: $fontColor;
          button {
            float: right;
            margin-top: 36px;
            height: 28px;
            padding: 0 10px;
            /*width: 100px;*/
            line-height: 28px;
            border: none;
            outline: none;
            color: white;
            margin-right: 20px;
            background-color: $navcolor;
          }
          button:nth-child(2) {
            margin-right: 20px;
            color: black;
            background-color: #f0f0f0;
            /*border: 1px solid black;*/
          }
        }
      }
    }
    .cart_Mmain {
      display: none;
    }
    /*<!--.cart_bottom {-->*/
    /*<!--margin-top: 100px;-->*/
    /*<!--height: 100px;-->*/
    /*<!--width: 100%;-->*/
    /*<!--background-color: $bgcolor;-->*/
    /*<!--}-->*/
    .no_goods {
      margin: 0 auto;
      height: 315px;
      width: 100%;
      line-height: 326px;
      display: flex;
      justify-content: center;
      font-size: 18px;
      letter-spacing: 2px;
      padding: 100px 0;
      /*background-color: red;*/
    }
    .Mno_goods {
      display: none;
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/cart/shop.vue